<template>
  <el-dialog
    :title="type === 1 ? '代收通道配置' : '代付通道配置'"
    :visible="visible"
    width="1200px"
    :destroy-on-close="true"
    :lock-scroll="false"
    @update:visible="updateVisible">
    <el-table :data="channelList" v-loading="loading" stripe border>
      <el-table-column label="通道类型" align="center" min-width="120">
        <template slot-scope="scope">
          {{ scope.row.channel_name }}
        </template>
      </el-table-column>
      <el-table-column label="通道列表" align="center" min-width="200">
        <template slot-scope="scope">
          <el-select
            v-model="scope.row.channel_id"
            multiple
            filterable
            collapse-tags
            placeholder="请选择"
            style="width: 100%"
            @change="onChannelChange(scope.row)">
            <el-option :value="ROUND_VALUE" label="轮询" />
            <el-option
              v-for="item in scope.row.channels"
              :key="item.id"
              :value="Number(item.id)"
              :label="item.up_channel_name" />
          </el-select>
        </template>
      </el-table-column>
      <el-table-column label="货币类型" align="center" min-width="160">
        <template slot-scope="scope">
          <el-select
            v-model="scope.row.cny_id"
            clearable
            filterable
            placeholder="请选择"
            style="width: 100%">
            <el-option
              v-for="item in scope.row.cny"
              :key="item.id"
              :value="item.id"
              :label="currencyLabel(item)" />
          </el-select>
        </template>
      </el-table-column>
      <el-table-column label="费率 (%)" align="center" min-width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.rate" clearable placeholder="请输入">
            <template slot="append">%</template>
          </el-input>
        </template>
      </el-table-column>
      <el-table-column label="手续费 (元)" align="center" min-width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.fees" clearable placeholder="请输入">
            <template slot="append">元</template>
          </el-input>
        </template>
      </el-table-column>
      <el-table-column label="状态" align="center" min-width="100">
        <template slot-scope="scope">
          <el-switch v-model="scope.row.status" :active-value="1" :inactive-value="0" />
        </template>
      </el-table-column>
    </el-table>
    <div slot="footer">
      <el-button @click="updateVisible(false)">取消</el-button>
      <el-button @click="resetConfig" :disabled="loading">重置</el-button>
      <el-button type="primary" @click="save" :loading="saving">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
const ROUND_VALUE = 0;

export default {
  name: 'ChannelUserEdit',
  data() {
    return {
      userId: 0,
      type: 1,
      visible: false,
      channelList: [],
      loading: false,
      saving: false,
      ROUND_VALUE
    };
  },
  methods: {
    currencyLabel(item) {
      if (!item) return '';
      const name = item.cny_name || item.country;
      const code = item.cny_enname;
      return code ? `${name} (${code})` : name;
    },
    openMask(row = {}, type = 1) {
      this.userId = row.id || 0;
      this.type = type;
      this.visible = true;
      this.loadData();
    },
    normalizeRow(item) {
      const validIds = (item.channels || []).map((c) => Number(c.id)).filter((id) => id > 0);
      let channelIds = Array.isArray(item.channel_id)
        ? item.channel_id.map((id) => Number(id)).filter((id) => validIds.includes(id))
        : [];
      if (
        !channelIds.length
        || (validIds.length > 0 && channelIds.length === validIds.length
          && validIds.every((id) => channelIds.includes(id)))
      ) {
        channelIds = [ROUND_VALUE];
      }
      const cnyIds = (item.cny || []).map((c) => c.id);
      return {
        ...item,
        channel_id: channelIds,
        cny_id: cnyIds.includes(item.cny_id) ? item.cny_id : null,
        rate: item.rate != null ? String(item.rate) : '0.00',
        fees: item.fees != null ? String(item.fees) : '0.00',
        status: item.status || 0
      };
    },
    onChannelChange(row) {
      const ids = Array.isArray(row.channel_id) ? row.channel_id.map(Number) : [];
      if (!ids.includes(ROUND_VALUE)) {
        return;
      }
      if (ids.length === 1 || ids[ids.length - 1] === ROUND_VALUE) {
        row.channel_id = [ROUND_VALUE];
      } else {
        row.channel_id = ids.filter((id) => id !== ROUND_VALUE);
      }
    },
    resolveChannelIds(item) {
      const ids = Array.isArray(item.channel_id)
        ? item.channel_id.map((id) => Number(id))
        : [];
      if (!ids.length || ids.includes(ROUND_VALUE)) {
        return [];
      }
      return ids.filter((id) => id > 0);
    },
    loadData() {
      this.loading = true;
      this.$http
        .post('/channeluser/getlist', {
          type: this.type,
          user_id: this.userId
        })
        .then((res) => {
          this.loading = false;
          if (res.data.code !== 0) {
            this.$message.error(res.data.msg || '加载失败');
            return;
          }
          this.channelList = (res.data.data || []).map((item) => this.normalizeRow(item));
        })
        .catch((e) => {
          this.loading = false;
          this.$message.error(e.message);
        });
    },
    resetConfig() {
      this.channelList.forEach((item) => {
        item.channel_id = [];
        item.cny_id = null;
        item.rate = '0.00';
        item.fees = '0.00';
        item.status = 0;
      });
      this.$message.success('已重置');
    },
    save() {
      const payload = this.channelList.map((item) => ({
        channels_users_id: item.channels_users_id || 0,
        channel_type_id: item.id,
        channel_id: this.resolveChannelIds(item),
        cny_id: item.cny_id || 0,
        rate: item.rate || 0,
        fees: item.fees || 0,
        status: item.status || 0,
        type: this.type
      }));
      this.saving = true;
      this.$http
        .post('/channeluser/save', {
          user_id: this.userId,
          json: JSON.stringify(payload)
        })
        .then((res) => {
          this.saving = false;
          if (res.data.code === 0) {
            this.$message.success(res.data.msg || '保存成功');
            this.updateVisible(false);
            this.$emit('done');
          } else {
            this.$message.error(res.data.msg || '保存失败');
          }
        })
        .catch((e) => {
          this.saving = false;
          this.$message.error(e.message);
        });
    },
    updateVisible(value) {
      this.visible = value;
    }
  }
};
</script>
